module.exports = __webpack_public_path__ + "static/img/diffuse_redness-01.5a7ced0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/diffuse_redness-01.jpg
// module id = 261
// module chunks = 1